<script setup lang="ts">
import { onMounted } from 'vue';

import { useRecipeStore } from '@apps/main/new-desktop/core/stores/recipe/recipeStore';

import { AppDrawer } from '@libs/ui';

import { useActivityDetailsStore } from '../../stores';
import TicketsSelectorMobileLoader from '../loaders/TicketsSelectorMobileLoader.vue';
import { useActivityDetailsTicketsStore } from '../../stores/activityDetailsTicketsStore';

import TicketsSelectorMobile from './TicketsSelectorMobile.vue';

const activityDetailsStore = useActivityDetailsStore();
const activityDetailsTicketsStore = useActivityDetailsTicketsStore();
const recipeStore = useRecipeStore();

interface TicketsSelectorPanelEmits {
  (event: 'close'): void;
  (event: 'select-tickets'): void;
}
const emit = defineEmits<TicketsSelectorPanelEmits>();

function handleSelectTicket(): void {
  activityDetailsTicketsStore.selectTicket();
  emit('select-tickets');
}

onMounted(() => {
  const initialTickets = recipeStore.selectedActivityTickets.map((ticket) => ({
    code: ticket.code,
    ageRangeId: ticket.ageRangeId,
    quantity: ticket.quantity,
    dateOffset: ticket.dateOffset,
    timeSlotId: ticket.timeSlotId,
  }));
  activityDetailsTicketsStore.setInitialTickets(initialTickets);
});
</script>

<template>
  <AppDrawer @close="emit('close')">
    <template #header>
      <span class="title">{{ $t('planner.select_ticket') }}</span>
    </template>
    <template #content>
      <TicketsSelectorMobileLoader
        v-if="activityDetailsStore.isLoading"
        @close="emit('close')"
      />
      <TicketsSelectorMobile
        v-else
        :activity-details-footer-data="
          activityDetailsTicketsStore.activityDetailsFooterData
        "
        @close="emit('close')"
        @select-tickets="handleSelectTicket"
      />
    </template>
  </AppDrawer>
</template>

<style scoped lang="scss">
.title {
  @include font-body-l-bold;
  color: var(--color-neutral-70);
}
</style>
